// Web-only stand-in for "react-native-webview", which has no web implementation.
// webpack.config.js aliases the package here.
//
// Renders the target in an <iframe>. Many external sites (including 4schools.io
// sign-in) send X-Frame-Options/CSP headers that forbid framing, and a parent
// page cannot detect that cross-origin — so an "open in a new tab" affordance is
// always shown rather than being a hidden fallback.

import React from "react";
import { Linking, StyleSheet, Text, TouchableOpacity, View } from "react-native";

export interface WebViewSource {
	uri?: string;
	html?: string;
}

export interface WebViewProps {
	source: WebViewSource;
	style?: any;
	// Accepted and ignored: the native-only props the app passes through.
	[key: string]: any;
}

export const WebView = ({ source, style }: WebViewProps) => {
	const uri = source?.uri;
	const html = source?.html;

	const openExternally = () => {
		if (uri) Linking.openURL(uri);
	};

	return (
		<View style={[styles.root, style]}>
			{uri ? (
				<View style={styles.notice}>
					<Text style={styles.noticeText} numberOfLines={1}>
						{uri}
					</Text>
					<TouchableOpacity onPress={openExternally}>
						<Text style={styles.noticeLink}>Abrir em nova aba</Text>
					</TouchableOpacity>
				</View>
			) : null}
			{React.createElement("iframe", {
				src: uri,
				srcDoc: html,
				style: {
					border: "none",
					width: "100%",
					flexGrow: 1,
					backgroundColor: "#fff",
				},
				referrerPolicy: "no-referrer-when-downgrade",
				sandbox: "allow-scripts allow-same-origin allow-forms allow-popups",
			})}
		</View>
	);
};

export default WebView;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
	},
	notice: {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		paddingHorizontal: 12,
		paddingVertical: 8,
		backgroundColor: "#f2f4f5",
		borderBottomWidth: 1,
		borderBottomColor: "#e0e3e5",
	},
	noticeText: {
		flexShrink: 1,
		fontSize: 12,
		color: "#6b7378",
		marginRight: 12,
	},
	noticeLink: {
		fontSize: 12,
		fontWeight: "bold",
		color: "#1f6feb",
	},
});
